import { getSkinId } from 'src/helpers/utils';
import HttpClient from './http';

const getRaces = (): Promise<any> => {
  return HttpClient.get(
    {
      path: '/api/getRaces',
      baseURL: process.env.REACT_APP_GAME_BOX as string,
    },
    false,
    {
      type: 'regular',
      operatorId: getSkinId(),
    }
  );
};

export { getRaces };
